import * as React from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import qs from 'qs'

import BannerWithFeatured from '../BannerWithFeatured/BannerWithFeatured'
import EventsSection from '../EventsSection/EventsSection'
import PopupModal from '../PopupModal/PopupModal'
import PromosSection from '../PromosSection/PromosSection'
import MallModalPreview from '../MallModal/MallModal'

class MainView extends React.Component {
  state = {
    featuredPreview: null,
    heroBannerPreview: null,
    eventPreview: null,
    promoPreview: null,
    popupPreview: null,
    articlePreview: null,
    mallPreview: null,
    displayOption: null,
  }

  componentDidMount() {
    this.getBlobData()
  }

  getBlobData = async () => {
    const { location, match } = this.props
    const { component } = match.params

    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })

    const { params, option: displayOption } = queryParams

    this.setState({ displayOption })
    try {
      const blobResponse = await axios.get(params, {
        responseType: 'blob',
      })
      const reader = new FileReader()
      reader.addEventListener('loadend', e => {
        const text = e.srcElement.result

        const data = JSON.parse(text)
        const displayData = { ...data, displayOption }
        this.setState({
          heroBannerPreview:
            ['hero-banner', 'hero-banner-preview'].indexOf(component) >= 0
              ? displayData
              : null,
          featuredPreview: component === 'featured' ? displayData : null,
          eventPreview:
            component === 'event'
              ? {
                  ...displayData,
                  imageUrl: displayData.bannerImage.url,
                  logoUrl: displayData.featuredImage.url,
                }
              : null,
          promoPreview:
            component === 'promo'
              ? {
                  ...displayData,
                  imageUrl: displayData.bannerImage.url,
                  logoUrl: displayData.featuredImage.url,
                }
              : null,
          popupPreview:
            component === 'popup'
              ? {
                  ...displayData,
                  popupType: displayData.popupType
                    ? parseInt(displayData.popupType)
                    : displayData.layout && parseInt(displayData.layout),
                  mobileImageUrl:
                    displayData.mobileImageUrl &&
                    (displayData.mobileImageUrl.url ||
                      displayData.mobileImageUrl),
                  desktopImageUrl:
                    displayData.desktopImageUrl &&
                    (displayData.desktopImageUrl.url ||
                      displayData.desktopImageUrl),
                }
              : null,
          articlePreview:
            component === 'marketing-content'
              ? {
                  ...displayData,
                  imageUrl: displayData.desktopBanner.url,
                  logoUrl: displayData.mobileBanner.url,
                }
              : null,
          mallPreview:
            component === 'mall'
              ? {
                  ...displayData,
                  logoUrl: displayData.logoUrl.url,
                }
              : null,
          adSpotPreview:
            component === 'ad'
              ? {
                  ...displayData,
                  imageUrl: displayData.bannerImage.url,
                  logoUrl: displayData.featuredImage.url,
                }
              : null,
          displayOption,
        })
      })

      reader.readAsText(blobResponse.data)
    } catch (error) {}
  }

  render() {
    const {
      featuredPreview,
      heroBannerPreview: bannerData,
      eventPreview,
      promoPreview,
      popupPreview,
      articlePreview,
      adSpotPreview,
      displayOption,
      mallPreview,
    } = this.state

    const featuredData =
      `${displayOption}` === '2'
        ? featuredPreview || eventPreview || promoPreview
        : featuredPreview
    const eventData = `${displayOption}` === '0' ? eventPreview : null
    const promoData = `${displayOption}` === '0' ? promoPreview : null
    const listViewData =
      `${displayOption}` === '1'
        ? featuredPreview || eventPreview || promoPreview
        : null

    if (featuredData || bannerData || listViewData) {
      return (
        <BannerWithFeatured
          featuredPreview={featuredData}
          bannerLayout={featuredData ? 0 : displayOption}
          heroBannerPreview={bannerData}
          listViewPreview={listViewData}
        />
      )
    }
    if (eventData) {
      return <EventsSection eventPreview={eventPreview} />
    }
    if (promoData) {
      return <PromosSection promoPreview={promoPreview} />
    }
    if (popupPreview) {
      return <PopupModal popupPreview={popupPreview} />
    }
    if (articlePreview) {
      if (String(displayOption) === '0')
        return (
          //featured
          <BannerWithFeatured
            featuredPreview={articlePreview}
            bannerLayout={articlePreview ? 0 : displayOption}
            heroBannerPreview={bannerData}
            listViewPreview={null}
          />
        )
      if (String(displayOption) === '1')
        return (
          //featured list
          <BannerWithFeatured
            featuredPreview={articlePreview}
            bannerLayout={articlePreview ? 0 : displayOption}
            heroBannerPreview={bannerData}
            listViewPreview={articlePreview}
          />
        )
      if (String(displayOption) === '2')
        return (
          //section
          <EventsSection eventPreview={articlePreview} />
        )
    }
    if (adSpotPreview) {
      if (String(displayOption) === '0')
        return (
          //featured list
          <BannerWithFeatured
            featuredPreview={adSpotPreview}
            bannerLayout={adSpotPreview ? 0 : displayOption}
            heroBannerPreview={bannerData}
            listViewPreview={adSpotPreview}
          />
        )
      if (String(displayOption) === '1')
        return (
          //featured
          <BannerWithFeatured
            featuredPreview={adSpotPreview}
            bannerLayout={adSpotPreview ? 0 : displayOption}
            heroBannerPreview={bannerData}
            listViewPreview={null}
          />
        )
      if (String(displayOption) === '2')
        return (
          //promos section
          <PromosSection promoPreview={adSpotPreview} />
        )

      if (String(displayOption) === '3')
        return (
          //events section
          <EventsSection eventPreview={adSpotPreview} />
        )
    }
    if (mallPreview) {
      return <MallModalPreview mallPreview={mallPreview} />
    }

    return <></>
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
